import React, { createContext, useContext, useReducer, useEffect } from 'react';
// Actions
import { classes as ctaLogClasses } from '../actions/ctalogs';
// Utils
import { sortList } from '../utils/Sort';

const CTALogClassesContext = createContext();

const initialState = {
  data: [],
  sort: {
    type: null,
    accessor: null,
  },
  loading: true,
  reload: false,
  filters: {
    application: null,
  },
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return { ...state, data: action.payload, loading: false };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_SORT':
      return { ...state, sort: action.payload };
    case 'SET_RELOAD':
      return { ...state, reload: action.payload };
    case 'SET_FILTERS':
      return { ...state, filters: action.payload };
    default:
      return state;
  }
};

export const CTALogClassesDataProvider = ({ children }) => {
  // useReducer
  const [state, dispatch] = useReducer(dataReducer, initialState);

  useEffect(() => {
    const fetchClassesData = async () => {
      await ctaLogClasses({
        applicationId: state.filters.application,
        success: (data) => {
          handleSorting(data);
        },
        error: (error) => {
          throw new Error('Failed to fetch data');
        },
      });
    };

    fetchClassesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filters.application, state.reload]);

  useEffect(() => {
    handleSorting(state.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.sort]);

  // Methods
  const handleSorting = (data) => {
    if (state.sort.accessor && state.sort.type) {
      const sortedList = sortList(data, state.sort.accessor, state.sort.type);

      dispatch({ type: 'SET_DATA', payload: sortedList.data });
    } else {
      dispatch({ type: 'SET_DATA', payload: data });
    }
  };

  return <CTALogClassesContext.Provider value={{ state, dispatch }}>{children}</CTALogClassesContext.Provider>;
};

export const useCTALogClassesData = () => {
  const context = useContext(CTALogClassesContext);
  if (!context) {
    throw new Error('useCTALogClassesData must be used within a CTALogClassesDataProvider');
  }
  return context;
};
